import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { Stack } from '@mui/material';
import { GoogleChartWrapper } from '../../../../../v2/components/charts/GoogleChartWrapper';
import { useReducer } from 'react';
const XReducer = (prev, next) => {
    return { ...prev, ...next };
};
export const ChartExample = ({}) => {
    const [state, dispatch] = useReducer(XReducer, { recipient: null, subject: null, content: null });
    const {} = state;
    const pieChartData = new google.visualization.DataTable();
    pieChartData.addColumn('string', 'Topping');
    pieChartData.addColumn('number', 'Slices');
    pieChartData.addRows([
        ['Mushrooms', 3],
        ['Onions', 1],
        ['Olives', 1],
        ['Zucchini', 1],
        ['Pepperoni', 2],
    ]);
    const lineChartData = new google.visualization.DataTable();
    lineChartData.addColumn('number', 'X');
    lineChartData.addColumn('number', 'Y');
    const sinewWave25Points = Array.from({ length: 25 }, (_, i) => {
        const x = i / 4;
        return [x, Math.sin(x)];
    });
    lineChartData.addRows(sinewWave25Points);
    const barChartData = new google.visualization.DataTable();
    barChartData.addColumn('string', '    City');
    barChartData.addColumn('number', '2010 Population');
    barChartData.addColumn('number', '2000 Population');
    barChartData.addRows([['New York City, NY', 8175000, 8008000],
        ['Los Angeles, CA', 3792000, 3694000],
        ['Chicago, IL', 2695000, 2896000],
        ['Houston, TX', 2099000, 1953000],
        ['Philadelphia, PA', 1526000, 1517000],]);
    const classMap = {
        AreaChart: google.visualization.AreaChart,
        BarChart: google.visualization.BarChart,
        BubbleChart: google.visualization.BubbleChart,
        CandlestickChart: google.visualization.CandlestickChart,
        ColumnChart: google.visualization.ColumnChart,
        ComboChart: google.visualization.ComboChart,
        GeoChart: google.visualization.GeoChart,
        Histogram: google.visualization.Histogram,
        LineChart: google.visualization.LineChart,
        PieChart: google.visualization.PieChart,
        ScatterChart: google.visualization.ScatterChart,
        SteppedAreaChart: google.visualization.SteppedAreaChart,
    };
    const dataMap = {
        LineChart: lineChartData,
        PieChart: pieChartData,
        BarChart: barChartData,
    };
    return (_jsxs(Stack, { children: [_jsx(Typography, { variant: 'body1', children: "Page Name" }), _jsxs(Stack, { direction: 'row', spacing: 2, alignItems: 'center', children: [_jsx(GoogleChartWrapper, { chartClass: classMap.PieChart, data: dataMap.PieChart, fragmentProps: { style: { height: 500, width: 500 } } }), _jsx(GoogleChartWrapper, { chartClass: classMap.LineChart, data: dataMap.LineChart, fragmentProps: { style: { height: 300, width: 300 } } }), _jsx(GoogleChartWrapper, { chartClass: classMap.BarChart, data: dataMap.BarChart, fragmentProps: { style: { height: 300, width: 300 } } })] })] }));
};
